import Chainable from './Chainable';

let chainable = new Chainable();

console.log(chainable.add(3));
console.log(chainable.add(4));
console.log(chainable.multiply(3));
